export enum AdGroupAdStatus {
  ENABLED,
  PAUSED,
  DISABLED,
  ARCHIVED,
}
